import { render, staticRenderFns } from "./SinglefileUpload.vue?vue&type=template&id=19b61388&"
import script from "./SinglefileUpload.vue?vue&type=script&lang=js&"
export * from "./SinglefileUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports